<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-16 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-16 10:39:49
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.priceModeApplyCode"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="数据来源：" :value="headInfo.dataSource" :options="dataSourceOptions"></hi-cell>
    <hi-cell title="采购组织：" :value="headInfo.purorgName"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    dataSourceOptions() {
      return this.$store.getters.dicts.data_source
    }
  }
}
</script>
